import React from 'react'
import { Routes, Route, Link } from "react-router-dom";
import Health from '../pages/Health';
import Home from '../pages/Home';
import World from '../pages/World';
import Brown from '../pages/Brown';
import Nav1 from './Nav1';
import Details from './Details';
import Entertainment from './Entertainment';
function Nav() {
  return (
    <>
     <nav className="navbar navbar-expand-lg py-0 sticky-top bg">
  <div className="container">
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon" />
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        <li className="nav-item  py-3 px-2">
          <Link className="nav-link text-light" aria-current="page" to="/">HOME</Link>
        </li>
        <li className="nav-item  py-3 px-2">
          <Link className="nav-link text-light" aria-current="page" to="/health">HEALTH</Link>
        </li>
        <li className="nav-item  py-3 px-2">
          <Link className="nav-link text-light" aria-current="page" to="/world">WORLD</Link>
        </li>
        <li className="nav-item  py-3 px-2">
          <Link className="nav-link text-light" aria-current="page" to="#">ENTERTAINMENT</Link>
        </li>
        <li className="nav-item  py-3 px-2">
          <Link className="nav-link text-light" aria-current="page" to="#">TRAVEL</Link>
        </li>
        <li className="nav-item dropdown py-3 px-2">
          <a className="nav-link dropdown-toggle text-light" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          PAGE
          </a>
          <ul className="dropdown-menu drop">
            <li><a className="dropdown-item" href="#">HOME RIGHT SIDEBAR</a></li>
          </ul>
        </li>
      </ul>
      <form className="d-flex text-body-tertiary float-end position-relative" role="search">
        <input className="form-control position-relative sear py-2 px-4" type="search" placeholder="Search News.." aria-label="Search" />
        <i class="bi bi-search fs-5 position-absolute search"></i>
      </form>
    </div>
  </div>
</nav>
<div className='container'>
  <Brown/>
<div className='row mt-4 pt-4'>
   <div className='col-lg-8'>
    <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/health" element={<Health />} />
        <Route path="/world" element={<World />} />
        <Route path="/entertainment" element={<Entertainment />} />
        <Route path="/details/:did" element={<Details />} />
      </Routes>
  </div>
  <div className='col-lg-4'>
    <Nav1/>
  </div>
    </div>
    </div>
    </>
  )
}

export default Nav
